import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Utente,
  CreateDipendenteDto,
  DipendentiQueryParams,
  DatiAziendaDto,
  UpdateDatiAziendaDto
} from '../../core/models/utente.mdoel';

export const DipendentiActions = createActionGroup({
  source: 'Dipendenti',
  events: {
    'Load List': emptyProps(),
    'Load List Success': props<{ items: Utente[]; totalElements: number; totalPages: number; pageIndex: number }>(),
    'Load List Failure': props<{ error: string }>(),

    'Load List Paginated': props<{ params?: DipendentiQueryParams }>(),
    'Load List Paginated Success': props<{ items: Utente[]; totalElements: number; totalPages: number; pageIndex: number }>(),
    'Load List Paginated Failure': props<{ error: string }>(),

    'Load Details': props<{ id: number }>(),
    'Load Details Success': props<{ item: Utente }>(),
    'Load Details Failure': props<{ error: string }>(),

    'Create': props<{ dto: CreateDipendenteDto }>(),
    'Create Success': emptyProps(),
    'Create Failure': props<{ error: string }>(),

    'Update': props<{ id: number; dto: CreateDipendenteDto }>(),
    'Update Success': emptyProps(),
    'Update Failure': props<{ error: string }>(),

    'Archive': props<{ id: number; archive: boolean }>(),
    'Archive Success': emptyProps(),
    'Archive Failure': props<{ error: string }>(),

    'Load Dati Azienda': props<{ id: number }>(),
    'Load Dati Azienda Success': props<{ item: DatiAziendaDto }>(),
    'Load Dati Azienda Failure': props<{ error: string }>(),

    'Update Dati Azienda': props<{ id: number; dto: UpdateDatiAziendaDto }>(),
    'Update Dati Azienda Success': props<{ id: number }>(),
    'Update Dati Azienda Failure': props<{ error: string }>(),

    'Upload Logo Dati Azienda': props<{ id: number; file: File }>(),
    'Upload Logo Dati Azienda Success': props<{ id: number }>(),
    'Upload Logo Dati Azienda Failure': props<{ error: string }>(),
  },
});
